import { gql } from "@apollo/client";

export const GENERATE_CODE = gql`
  mutation GenerateCode($input: GenerateCodeInput!) {
    GenerateCode(input: $input) {
      message
    }
  }
`;
